import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from 'environments/environment';

type PublishedFor = 'staging' | 'kiosk' | 'production';

@Injectable()
export class ShutdownKioskGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of((environment.publishedFor as PublishedFor) === 'production');
  }
}